import React from 'react';
import VolumeWidgetRenderer from './VolumeWidgetRenderer';

const Preview: React.FC = () => (
  <VolumeWidgetRenderer config={{}} />
);

export default Preview;
